import { FilterTableInputType, InputType } from '@zspace/types';
import { Dispatch, SetStateAction, useCallback } from 'react';
import FilterBarItem from '../filter-bar-item/filter-bar-item';
import { FilterCriteriaInput } from './inputs/filter-criteria-input/filter-criteria-input';
import { SelectChecklistInput } from './inputs/select-checklist-input/select-checklist-input';

export type FilterBarItemInput<T> = Pick<
  FilterBarInputProps<T>,
  'localData' | 'setLocalData' | 'title' | 'onValidateField' | 'errorText'
>;

export type FilterBarInputProps<T> = {
  title: string;
  filterKey: string;
  appliedCount: number;
  input: FilterTableInputType<T>;
  localData: T;
  setLocalData: Dispatch<SetStateAction<T>>;
  onClear: () => void;
  onSubmit: (values: T) => void;
  errorText?: string;
  onValidateField?: (fieldName: string, valid: boolean) => void;
};

export function FilterBarInput<T>({
  title,
  filterKey,
  appliedCount,
  input,
  localData,
  setLocalData,
  onClear,
  onSubmit,
  errorText,
  onValidateField,
}: FilterBarInputProps<T>) {
  const handleSubmit = useCallback(() => {
    onSubmit(localData);
  }, [localData, onSubmit]);

  const handleClear = useCallback(() => {
    onClear();
  }, [onClear]);

  return (
    <FilterBarItem
      title={title}
      appliedCount={appliedCount}
      onClear={handleClear}
      onSubmit={handleSubmit}
    >
      {input.type === InputType.FILTER_CRITERIA && (
        <FilterCriteriaInput
          name={filterKey}
          localData={localData}
          setLocalData={setLocalData}
          onValidateField={onValidateField}
          errorText={errorText}
          input={input}
        />
      )}
      {input.type === InputType.SELECT && (
        <SelectChecklistInput
          name={filterKey}
          localData={localData}
          setLocalData={setLocalData}
          onValidateField={onValidateField}
          errorText={errorText}
          input={input}
        />
      )}
    </FilterBarItem>
  );
}

export default FilterBarInput;
